import React, { useEffect, useState } from "react";
import Chart from "react-apexcharts";
import { DashboardAcompProducaoDashSemanal } from "../../../components/classes/DashAcompProducao";

import { useTranslation } from "react-i18next";

export default function ChartProd02(props: ChartProd02Props) {
  const { t } = useTranslation();

  const [seriesMixedChart, setSeriesMixedChart] = useState<{ name: string, type: string, data: number[] }[]>([]);
  const [optionsMixedChart, setOptionsMixedChart] = useState<ApexCharts.ApexOptions>({
    dataLabels: {
      enabled: true,
      style: {
        fontSize: "13",
        fontFamily: "Roboto",
        colors: ['white']
      },
      background: {
        enabled: true,
        foreColor: 'black',
        padding: 4,
        borderRadius: 1,
        borderWidth: 1,
        borderColor: 'black',
        opacity: 0.9,
        dropShadow: {
          enabled: false,
          top: 1,
          left: 1,
          blur: 1,
          color: '#000',
          opacity: 0.45
        }
      },
    },
    plotOptions: {
      bar: {
        dataLabels: {
          orientation: "vertical",
          hideOverflowingLabels: true
        }
      }
    }
  });

  useEffect(() => {

    setSeriesMixedChart(
      [
        {
          name: t("pages.dashboardProductionMonitoring.text.planned"),
          type: "column",
          data: props?.data?.quantidadesPlanejadas ?? []
        },
        {
          name: t("pages.dashboardProductionMonitoring.text.produced"),
          type: "column",
          data: props?.data?.quantidadesProduzidas ?? []
        }
      ]
    );

    setOptionsMixedChart(
      {
        ...optionsMixedChart,
        xaxis: {
          type: "category",
          categories: props?.data?.semana?.map(x => x.descricao)
        }
      }
    );

  }, [props])

  return (
    <div id="chart001" className="mixed-chart">
      <Chart
        options={optionsMixedChart}
        series={seriesMixedChart}
        type="line"
        height={300}
      />
    </div>
  );
}

interface ChartProd02Props {
  data?: DashboardAcompProducaoDashSemanal
}